module.exports = __webpack_public_path__ + "static/media/visit.5656873a.svg";